import { Component, Element, Event, EventEmitter, h, Host, Method, Prop } from "@stencil/core";

@Component({
    tag: "ux-table-sort",
    styleUrl: "table-sort.scss",
    shadow: false
})
export class TableSort {
    @Element() domElement!: HTMLUxTableSortElement;
    /** This is the name to send when it should sort ascending */
    @Prop() readonly ascName: string;
    /** This is the name to send when it should sort descending */
    @Prop() readonly descName: string;
    /**
     * indicates in which direction the data is already sorted.
     * This has to be empty when it is not sorted yet. Setting this does not trigger the sorting event.
     * Clicking the button will update this attribute. */
    @Prop({ reflect: true, mutable: true }) sortedDirection: "" | "asc" | "desc" = "";
    /** if set, the sorting will be executed on a numerical value */
    @Prop() readonly numerical: boolean = false;
    /** when the sort Button is clicked it emits the asc or desc name  */
    @Event({
        eventName: "uxTableSort",
        composed: true,
        cancelable: true,
        bubbles: true
    })
    sortEvent!: EventEmitter<{ name: string; numerical: boolean }>;

    /** sort ascending */
    @Method()
    async sortAsc() {
        this.sort("asc");
    }

    /** sort descending */
    @Method()
    async sortDesc() {
        this.sort("desc");
    }

    // @ts-expect-error Check for typing
    private sort(direction: "asc" | "desc" = null): void {
        if (direction === null) {
            this.sortedDirection = this.sortedDirection !== "asc" ? "asc" : "desc";
        } else {
            this.sortedDirection = direction;
        }
        const name = this.sortedDirection === "asc" ? this.ascName : this.descName;
        this.sortEvent.emit({
            name: name,
            numerical: this.numerical
        });
        // @ts-expect-error Check for typing
        const allSorters = this.domElement.closest("tr").querySelectorAll("ux-table-sort");
        [].forEach.call(allSorters, (element: HTMLUxTableSortElement) => {
            if (element.isEqualNode(this.domElement)) {
                return;
            }
            element.sortedDirection = "";
        });
    }

    render() {
        const baseClass = "ux-table-sort";
        return (
            <Host class={baseClass} onClick={() => this.sort()}>
                <span class={`${baseClass}__text`}>
                    <slot />
                </span>
                &nbsp;
                <ux-icon class={`${baseClass}__icon`} name="sort" weight="bold" />
            </Host>
        );
    }
}
